import React from "react";
import Text from "components/ui/Text";

interface Props {
  text: string;
}

export const AlertItem: React.FC<Props> = ({ text }) => {
  return (
    <div className="flex gap-1">
      <span>•</span>
      <Text fontSize={15} fontWeight={400} color="#51525C">
        {text}
      </Text>
    </div>
  );
};
